const state = {
    itemuom: [],
};

export default state;